import type { CommonColumns } from './common_columns';
import { commonColumns } from './common_columns';
import { companies } from './companies';
import { organizations } from './organizations';

export type OrganizationAdmins = CommonColumns & {
  resourceName: string;
  status: string;
  role: string;
  invitationSentAt: string;
  invitationAcceptedAt: string;
  adminId: string;
  adminFamilyName: string;
  adminGivenName: string;
  adminEmail: string;
  organizationId: string;
  organizationName: string;
  organizationMemo: string;
  adminMasked: string;
  companyId: string;
  companyName: string;
  otherOwnerExists: string;
};

// FIXME: refine
export const organizationAdmins: Readonly<OrganizationAdmins> = {
  ...commonColumns,
  ...{
    resourceName: '組織管理者',
    status: 'ステータス',
    role: '権限',
    invitationSentAt: '招待メール送信日時',
    invitationAcceptedAt: '招待メール承認日時',
    adminId: '管理者ID',
    adminFamilyName: '管理者姓',
    adminGivenName: '管理者名',
    adminEmail: '管理者メールアドレス',
    organizationId: `${organizations.resourceName}${organizations.id}`,
    organizationName: organizations.name,
    organizationMemo: `${organizations.resourceName}メモ`,
    adminMasked: 'マスク済',
    companyId: `${companies.resourceName}${companies.id}`,
    companyName: companies.name,
    otherOwnerExists: 'オーナー権限の組織管理者有り',
  },
};

export const organizationAdminsStatuses: ReadonlyArray<string> = [
  'active',
  'inactive',
  'pending',
];

// FIXME: refine
export const organizationAdminsStatusesName = (
  role: string | undefined
): string => {
  switch (role) {
    case 'active':
      return '有効 (アクティブ)';
    case 'inactive':
      return '無効 (非アクティブ)';
    case 'pending':
      return '招待中';
    default:
      return '';
  }
};

export const organizationAdminsRoles: ReadonlyArray<string> = [
  'owner',
  'admin',
];

// FIXME: refine
export const organizationAdminsRolesName = (
  role: string | undefined
): string => {
  switch (role) {
    case 'owner':
      return 'オーナー';
    case 'admin':
      return '管理者';
    default:
      return '';
  }
};
